import React from 'react';
import { Control, Controller } from 'react-hook-form';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  TextField,
} from '@mui/material';
import { Briefcase } from 'lucide-react';
import { useResources } from '../../../../hooks/resource/useResources';
import { CreateBookingDTO } from '../../../../types/booking';
import SectionTitle from './SectionTitle';
import { useAuth } from '../../../../hooks';
import { AUTH_CONSTANTS } from '../../../../config/constants';

interface ResourceSectionProps {
  control: Control<CreateBookingDTO>;
  disabled?: boolean;
}

const ResourceSection: React.FC<ResourceSectionProps> = ({ control, disabled = false }) => {
  const { resources } = useResources();
  const { role, clientResourceId } = useAuth();

  // Find the selected resource name
  const selectedResource = resources.find(res => res.id === clientResourceId);

  return (
    <div>
      <SectionTitle icon={Briefcase} title="Select Staff Member" />
      {clientResourceId && selectedResource && role === AUTH_CONSTANTS.ROLES.USER ? (
        <TextField
          fullWidth
          label="Selected Staff Member"
          value={selectedResource.name}
          InputProps={{ readOnly: true }}
        />
      ) : (
        <Controller
          name="resourceId"
          control={control}
          rules={{ required: 'Staff member is required' }}
          render={({ field, fieldState: { error } }) => (
            <FormControl fullWidth error={!!error}>
              <InputLabel>Select Staff Member</InputLabel>
              <Select
                {...field}
                label="Select Staff Member"
                disabled={disabled}
                value={resources.length > 0 ? field.value || '' : ''}
              >
                {resources.map(resource => (
                  <MenuItem key={resource.id} value={resource.id}>
                    {resource.name}
                  </MenuItem>
                ))}
              </Select>
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
          )}
        />
      )}
    </div>
  );
};

export default ResourceSection;
